import React from 'react';
import type { ApartmentMember } from '../../api/apartmentsApi';

interface MobileAppLinkStatusProps {
  member: Pick<ApartmentMember, 'userId' | 'user'>;
  t: (key: string) => string;
  compact?: boolean;
}

export const MobileAppLinkStatus: React.FC<MobileAppLinkStatusProps> = ({
  member,
  t,
  compact = false,
}) => {
  const isLinked = Boolean(member.userId && member.user);

  if (!isLinked) {
    return (
      <span className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 whitespace-nowrap">
        {t('mobileAppNotLinked')}
      </span>
    );
  }

  const accountLabel = member.user?.name || member.user?.email || '—';

  if (compact) {
    return (
      <span
        className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 whitespace-nowrap"
        title={member.user?.email}
      >
        {t('mobileAppLinked')}
      </span>
    );
  }

  return (
    <div className="flex flex-col gap-0.5 min-w-0">
      <span className="inline-flex self-start px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 whitespace-nowrap">
        {t('mobileAppLinked')}
      </span>
      <span className="text-xs text-gray-600 truncate" title={member.user?.email}>
        {accountLabel}
      </span>
    </div>
  );
};
